const registerPath = {
  list: "register/list",
  titleList: "register/titleList",
  province: "register/province",
  aumphur: "register/aumphur",
  tumbol: "register/tumbol",
  zipcode: "register/zipcode",
  consent: "register/consent",
  personalRecord: "register/personalRecord",
  address: "register/address",
  education: "register/education",
  experience: "register/experience",
  property: "register/property",
  occupation: "register/occupation",
  business: "register/business",
  incompatibility: "register/incompatibility",
  political: "register/political",
  discipline: "register/discipline",
  knowledge: "register/knowledge",
  concept: "register/concept",
  affiliation: "register/affiliation",
  uploadFile: "register/uploadFile",
  uploadFile2: "register/uploadFile2",
  deleteFile: "register/deleteFile",
  candidate: "register/candidate",
  knowledgeAndAbility: "register/knowledge-and-ability",
  expertiseOrExperience: "register/expertise-or-experience",
  lastStep: "register/last-step",
  subscription: "register/subscription",
  signIn: "register/signIn",
  listHistory: "register/listHistory",
  fileAnnounceType: "register/file/announce-type",
  verifyAccount: "register/verify-account",
  forgotPassword: "register/forgot-password",
  resetPassword: "register/reset-password",
  prefixName: "register/prefix-name",
  educationList: "register/education-list",
  nationality: "register/nationality",
  userProfile: "register/user-profile",
  userInformation: "register/user-information",
  listForCommittee: "register/listForCommittee",
  listCandidateInfoById: "register/listCandidateInfoById",
  cancel: "register/cancel",
  actionViewFileHistory: "register/actionViewFileHistory",
  replacement: "register/replacement",
  formConfig: "register/form/config",
  consentsBySRDId: "register/consents",
  propertiesUploadFile: "register/properties-uploadfile",
  getAgeText: "register/getagetexxt",
  getSumDateText: "register/getsumdatetext",
};

const otherPath = {
  sso: "auth/register/sso",
  reportCV: "report/cv",
  reportApplicate: "report/applicate",
};

export { otherPath, registerPath };
